import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

//import CloseButton from './CloseButton'

export default class extends Component {
  constructor (props) {
    super(props)

    this.state = {
      //height: Object.keys(props.items).lenght * 18,//0,
      select: props.title,//null
      isOpen: false
    }

    this.handleClick = this.handleClick.bind(this)
    this.selectOption = this.selectOption.bind(this)
  }

  handleClick (e) {
    if (this.state.isOpen) {
      document.body.classList.add('hide-dropdown')
      setTimeout(() => {
        this.setState({ isOpen: false })
        document.body.classList.remove('hide-dropdown')
      }, 150)
    } else {
      this.setState({ isOpen: true }, () => {
        //this.setState({ height: Object.keys(this.props.items).lenght * 18})//window.innerHeight - (this.body.getBoundingClientRect().top + this.body.getBoundingClientRect().height) })
      })
    }  
  }

  selectOption (e) {
    this.setState({ select: this.props.items[e.target.dataset.option.toString()] }, () => {
      this.handleClick()
    })
    this.props.onSubmit(e.target.dataset.option.toString())
  }

  componentDidMount () {}

  render () {
    //const items = this.props.items
    const text = this.props.text
    const newclass = (this.props.class) ? this.props.class : "";
    //const classItem = (this.props.classItem) ? this.props.classItem : "Select-item";
    return (
      <div className={'Select ' + newclass}>
        <div className='Hide-body' onClick={this.handleClick} ref={el => { this.body = el }}>
          <span className={this.props.labelClass ? this.props.labelClass : 'Hide-label'} style={this.state.isOpen ? {'color': '#ff5027'} : {'color': '#000'}}>
            { this.state.select || (<FormattedMessage id='select.subject' />) }
          </span>
          
          {/*!this.state.select && (*/
            <span className='Select-icon'
              style={{
                transform: this.state.isOpen && 'rotate(-180deg)',
                transition: 'transform 200ms ease-out'
              }}
            >
              <svg xmlns='http://www.w3.org/2000/svg' width='41' height='24' viewBox='0 0 41 24'><path fill={this.state.isOpen ? '#ff5027' : '#000'} fillRule='evenodd' 
              d='M-.001 3.654l20.167 20.097L40.332 3.654 37.46.749 20.166 18 2.905.749z' /></svg>
            </span>
          /*)*/}
          {this.state.select && <button className='Select__submit Head'>→</button>}
        </div>
        {this.state.isOpen &&
          <div className='Hide-list'>
            {
              this.props.isHTML 
                ?
                <div className={this.props.textClass ? this.props.textClass : "Hide-text"} style={{marginRight: this.props.margin? '30px' : 0}} dangerouslySetInnerHTML={{ __html: text }}></div>
                :
                <div className={this.props.textClass ? this.props.textClass : "Hide-text"} style={{marginRight: this.props.margin? '30px' : 0}}>
                  {text}
              </div>
            }
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Hide.jsx